/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react";
import { connect } from "react-redux";
import {ISuggestion} from "../../../../types/suggestion";
import {updateMapPositionAction} from "../../../../state/geoMap/actions";
import {hasBeenFilled} from "../../../../helpers/dynamicFormHelper";

interface Iprops {
  name: string,
  className: string,
  isInvalid: boolean,
  value: string,
  suggestions?: ISuggestion[],
  disabled: boolean,
  onChangeHandler(event: any): void,
  setFieldValue(name: string, input: string): void,
  updateMapPositionActionHandler(inputs: any): void
}

interface Istate {
  activeSuggestion: number,
  showSuggestions: boolean,
  userInput: string
}

class Autocomplete extends Component<Iprops, Istate> {
  constructor(props) {
    super(props)

    this.state = {
      // The active selection's index
      activeSuggestion: 0,
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: props.value
    }
  }

  // Event fired when the input value is changed
  onChange = (e) => {
    this.props.onChangeHandler(e)
    // Update the user input and filtered suggestions, reset the active
    // suggestion and make sure the suggestions are shown
    this.setState({
      activeSuggestion: 0,
      showSuggestions: true,
      userInput: e.currentTarget.value
    })
  };

  // Event fired when the user clicks on a suggestion
  onClick = (e) => {
    this.props.setFieldValue(this.props.name, e.currentTarget.innerText)
    // Update the user input and reset the rest of the state
    this.setState({
      activeSuggestion: 0,
      showSuggestions: false,
      userInput: e.currentTarget.innerText || ""
    })
  };

  render() {
    const {
      onChange,
      onClick,
      state: {
        activeSuggestion,
        showSuggestions,
        userInput
      },
      props: {
        name,
        className,
        isInvalid,
        value,
        disabled,
        suggestions = [],
        updateMapPositionActionHandler
      }
    } = this;

    const isInputDisabled = disabled && hasBeenFilled(value);

    return (
      <>
        <input
          type="text"
          autoComplete="off"
          onChange={onChange}
          onKeyDown={() => {}}
          value={value}
          name={name}
          className={className + (isInvalid ? " is-invalid" : "")}
          disabled={isInputDisabled}
        />
        {
          (showSuggestions && userInput && suggestions.length > 0)
          && (
            <ul className="suggestions">
              {
                suggestions.slice(0, 10).map((suggestion, index) => {
                  let className;

                  // Flag the active suggestion with a class
                  if (index === activeSuggestion) {
                    className = "suggestion-active"
                  }

                  return (
                    <li
                      tabIndex={-1}
                      className={className}
                      key={suggestion.name + (suggestion.coordinates ? suggestion.coordinates[1] : "")}
                      onClick={(e) => {
                        updateMapPositionActionHandler({
                          center: suggestion.coordinates,
                          zoom: suggestion.score < 1 ? 15 : 9
                        })
                        onClick(e)
                      }}
                    >
                      {suggestion.name}
                    </li>
                  )
                })
              }
            </ul>
          )
        }
      </>
    )
  }
}

const mapDispatchToState = (dispatch) => ({
  updateMapPositionActionHandler: (e) => dispatch(updateMapPositionAction(e))
})

export default connect(null, mapDispatchToState)(Autocomplete)
